import { render, staticRenderFns } from "./Template48.vue?vue&type=template&id=19cdb2c6&scoped=true&"
import script from "./Template48.vue?vue&type=script&lang=js&"
export * from "./Template48.vue?vue&type=script&lang=js&"
import style0 from "./Template48.vue?vue&type=style&index=0&id=19cdb2c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdb2c6",
  null
  
)

export default component.exports